module.exports = __webpack_public_path__ + "img/balkon2.f3491fb7.png";